import "./App.css";
import { useState, useEffect } from "react";

import Header from "./components/Header";
import ProductList from "./components/ProductsList";
import Cart from "./components/Cart";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentSale, setCurrentSale] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);

  const notify = () => toast.warn("O produto já foi adicionado ao carrinho!");

  const handleRequisition = () => {
    fetch("https://hamburgueria-kenzie-json-serve.herokuapp.com/products")
      .then((response) => response.json())
      .then((response) => setProducts(response))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (products.length === 0) handleRequisition();
  }, [products, filteredProducts]);

  const showProducts = (inputValue) => {
    // Obs.: qualquer nome digitado no input, que não exista no banco de dados de produtos, vai tirar a vitrine da situação de filtro.
    setFilteredProducts(
      products.filter(
        (element) =>
          element.name.toLowerCase().includes(inputValue) ||
          element.category.toLowerCase().includes(inputValue)
      )
    );
  };

  const handleClick = (productId) => {
    let newCart = products.find((element) => element.id === productId);
    if (!currentSale.includes(newCart)) {
      setCurrentSale([...currentSale, newCart]);
    } else {
      notify();
    }
    addCart();
  };

  const addCart = () => {
    setCartTotal(
      currentSale.reduce(
        (previousValue, currentValue) => previousValue + currentValue.price,
        0
      )
    );
  };

  useEffect(addCart);

  const resetCart = () => {
    currentSale.splice(0, currentSale.length);
    handleRequisition();
  };

  const removeItemCart = (item) => {
    setCurrentSale(currentSale.filter((element) => element !== item));
  };

  return (
    <div className="App">
      <Header showProducts={showProducts} />
      <ul id="ul-cards">
        {filteredProducts.length !== 0 ? (
          <ProductList products={filteredProducts} handleClick={handleClick} />
        ) : (
          <ProductList products={products} handleClick={handleClick} />
        )}
      </ul>
      <Cart
        currentSale={currentSale}
        cartTotal={cartTotal}
        resetCart={resetCart}
        removeItemCart={removeItemCart}
      />
      <ToastContainer />
    </div>
  );
}

export default App;
